module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "container bg03"
  }, [_vm._m(0), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shop-proposals__tab-body bg05"
  }, [_c('div', {
    staticClass: "spacer",
    class: _vm.background,
    style: (_vm.padding)
  }, [_c('div', {
    staticClass: "offer-members__search"
  }, [_c('div', {
    staticClass: "offer-members__search__wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control offer-members__search__form",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "キーワードを入力"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "change": function($event) {
        _vm.rmEmoji(_vm.keyword)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _c('button', {
    staticClass: "offer-members__search__btn",
    on: {
      "click": function($event) {
        _vm.keywordSearch()
      }
    }
  })]), (_vm.keywordSearchCallbackFlag) ? _c('div', {
    staticClass: "frame01 offer-members__search__list",
    class: _vm.searchShow
  }, [_c('div', {
    staticClass: "user-outline"
  }, [_c('div', {
    staticClass: "user-outline__img",
    on: {
      "click": function($event) {
        _vm.search('keyword')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_loupe_circle.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "user-outline__body",
    on: {
      "click": function($event) {
        _vm.search('keyword')
      }
    }
  }, [_vm._m(1)])]), _vm._l((_vm.messageKeywordShops), function(keywordShop) {
    return (!_vm.isShopMaster) ? _c('div', {
      staticClass: "user-outline"
    }, [_c('div', {
      staticClass: "user-outline__img",
      on: {
        "click": function($event) {
          _vm.search('shop', keywordShop.id, keywordShop.attributes['shop-name'])
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../images/img_shop_circle.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body -shop",
      on: {
        "click": function($event) {
          _vm.search('shop', keywordShop.id, keywordShop.attributes['shop-name'])
        }
      }
    }, [_c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(keywordShop.attributes['shop-name']))])])]) : _vm._e()
  }), _vm._l((_vm.messageKeywordUsers), function(keywordUser) {
    return _c('div', {
      staticClass: "user-outline"
    }, [_c('div', {
      staticClass: "user-outline__img",
      on: {
        "click": function($event) {
          _vm.search('user', keywordUser.id)
        }
      }
    }, [(keywordUser.attributes['profile-image-path']) ? _c('img', {
      attrs: {
        "src": keywordUser.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    }) : _c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "user-outline__body",
      on: {
        "click": function($event) {
          _vm.search('user', keywordUser.id)
        }
      }
    }, [_c('p', {
      staticClass: "user-outline__body__role fz11"
    }, [_vm._v(_vm._s(keywordUser.attributes['shop-name']) + " " + _vm._s(keywordUser.attributes['user-type-name']))]), _c('h3', {
      staticClass: "user-outline__body__name fz16"
    }, [_vm._v(_vm._s(keywordUser.attributes['user-name']) + " " + _vm._s(keywordUser.attributes['user-firstname']))])])])
  })], 2) : _vm._e()]), (_vm.searchCallbackFlag && !!_vm.selectShopName) ? _c('div', {
    staticClass: "div"
  }, [_c('p', {
    staticClass: "shop-proposals__select__item -shop"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectShopName))])]), _c('hr'), _c('p')]) : _vm._e()])]), (_vm.searchCallbackFlag) ? _c('div', {
    staticClass: "div"
  }, _vm._l((_vm.messages), function(message) {
    return _c('div', {
      staticClass: "div"
    }, [_c('div', {
      staticClass: "user-post",
      class: _vm.unread(message.attributes['is-already-read']),
      on: {
        "click": function($event) {
          _vm.goMessageDetail(message.id)
        }
      }
    }, [(message.attributes['is-already-read'] == 0) ? _c('p', {
      staticClass: "-unread__txt"
    }, [_vm._v("未読")]) : _vm._e(), _c('div', {
      staticClass: "user-post__thumb"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goMessageDetail(message.id)
        }
      }
    }, [(message.attributes['profile-image-path']) ? _c('img', {
      attrs: {
        "src": message.attributes['profile-image-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      }
    }) : _c('img', {
      attrs: {
        "src": require("../images/img_profile.png"),
        "alt": ""
      }
    })])]), _c('div', {
      staticClass: "user-post__body",
      staticStyle: {
        "word-break": "break-word"
      }
    }, [_c('p', {
      staticClass: "user-post__body__info"
    }, [_c('a', {
      staticClass: "user-post__body__name",
      on: {
        "click": function($event) {
          _vm.goMessageDetail(message.id)
        }
      }
    }, [_vm._v(_vm._s(message.attributes['user-name']) + " " + _vm._s(message.attributes['user-firstname']))]), _c('span', {
      staticClass: "user-post__body__time",
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v(_vm._s(message.attributes['shop-name']) + " ")]), _c('br'), _c('span', {
      staticClass: "user-post__body__time"
    }, [_vm._v(_vm._s(message.attributes['created-at-format']))])]), _c('a', {
      staticClass: "user-post__body__link",
      on: {
        "click": function($event) {
          _vm.goMessageDetail(message.id)
        }
      }
    }, [_c('p', {
      staticClass: "user-post__body__excerpt",
      domProps: {
        "innerHTML": _vm._s(_vm.getMessageContent(message.attributes['content']))
      }
    })])])])])
  }), 0) : _vm._e(), (_vm.searchCallbackFlag && _vm.messages.length == 0) ? _c('div', {
    staticClass: "div text-center bg05"
  }, [_c('p', {
    staticClass: "no_propose_txt brown"
  }, [_vm._v("メッセージがありませんニャン。")])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h2', {
    staticClass: "moralcheck-title -var1"
  }, [_vm._v("メッセージが届いています")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "user-outline__body__name fz16"
  }, [_vm._v("上記キーワードを含む"), _c('br'), _vm._v("投稿を検索")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ed0c690!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/message-list.pug
// module id = 1438
// module chunks = 1